import { initializeDatadog } from "../utils/datadog.utils";

initializeDatadog();
